import { requestJson, toArray } from "./httpClient";

const orderOffersUrl = (orderId) => `/api/orders/${orderId}/offers`;

export const fetchOrderOffers = async (orderId) => {
    const data = await requestJson(orderOffersUrl(orderId), { cache: "no-store" });
    return toArray(data);
};

export const linkOfferToOrder = (orderId, offerId) =>
    requestJson(`${orderOffersUrl(orderId)}/${offerId}`, { method: "PUT" });

export const unlinkOfferFromOrder = (orderId, offerId) =>
    requestJson(`${orderOffersUrl(orderId)}/${offerId}`, { method: "DELETE" });
